import React from "react";
import { NavLink } from "react-router-dom";
import useHeader from "~components/Header/hooks/useHeader";
import { ArrowDownWalletMenu, CornerMenu } from "~misc/icons";
import { initialPath } from "~misc/paths";
import { toTestId } from "~services/utils/dataToTestId";

const NavTabs = ({ navs, customClasses }) => {
  const { path } = useHeader();
  if (navs.length === 1 && navs[0].link === "/carteira") {
    return (
      <>
        <nav className="hidden"></nav>
      </>
    );
  }
  return (
    <nav className="bg-terciaria full-screen-width py-2 lg:py-4 WalletMenu px-[26px] ">
      <div className="flex flex-wrap gap-4 md:gap-0 md:space-x-4 justify-between container">
        {navs.map((navItem, index, array) => (
          <NavLink
            key={index}
            to={`${initialPath}${navItem.link}`}
            end
            className={({ isActive, isPending, isTransitioning }) =>
              [
                navItem.className,
                isPending && "pending",
                isActive && "active",
                navItem.max && `max-w-[${navItem.max}]`,
                isTransitioning && "transitioning",
                path.replace(/\/$/, "") === `${initialPath}${navItem.link}`.replace(/\/$/, "") && "active",
                `relative text-white transition-all bg-primaria font-bold lg:text-lg flex-grow flex-shrink text-center py-3 px-8 rounded-lg ${customClasses}`,
              ].join(" ")

            }
            data-test-id={`${navItem.name}`}
          >
            {/* {index === 0 && (
              <ArrowDownWalletMenu className="absolute right-4 top-[60%] -translate-y-1/2 hidden md:block" />
            )} */}
            {index > 0 && path.replace(/\/$/, "") === `${initialPath}${navItem.link}`.replace(/\/$/, "") && (
              <CornerMenu className="-bottom-4 -left-5 -scale-100 rotate-90 absolute hidden md:block" />
            )}
            <span>{navItem.name}</span>
            {index < (array || []).length - 1 &&
              path.replace(/\/$/, "") === `${initialPath}${navItem.link}`.replace(/\/$/, "") && (
                <CornerMenu className="-bottom-4 -right-5 absolute hidden md:block" />
              )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default NavTabs;
